import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4a744934 = () => interopDefault(import('..\\pages\\document-error.vue' /* webpackChunkName: "pages_document-error" */))
const _5bc0329f = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _225da1cc = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _55192bda = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _3ae5339b = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _76f750ca = () => interopDefault(import('..\\pages\\signature.vue' /* webpackChunkName: "pages_signature" */))
const _d5a36be4 = () => interopDefault(import('..\\pages\\ssuccess.vue' /* webpackChunkName: "pages_ssuccess" */))
const _905b1dd6 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _efaac11a = () => interopDefault(import('..\\pages\\timeout.vue' /* webpackChunkName: "pages_timeout" */))
const _74d6e978 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _4ac12a3b = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _4acf41bc = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _4aeb70be = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _4af9883f = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _7fa7657c = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _2c3b1746 = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _0dc503fc = () => interopDefault(import('..\\pages\\patient\\success.vue' /* webpackChunkName: "pages_patient_success" */))
const _4248d50e = () => interopDefault(import('..\\pages\\representative\\patient-information.vue' /* webpackChunkName: "pages_representative_patient-information" */))
const _711c21d0 = () => interopDefault(import('..\\pages\\representative\\success.vue' /* webpackChunkName: "pages_representative_success" */))
const _a9e9de38 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/document-error",
    component: _4a744934,
    name: "document-error"
  }, {
    path: "/eligibility",
    component: _5bc0329f,
    name: "eligibility"
  }, {
    path: "/error",
    component: _225da1cc,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _55192bda,
    name: "have-a-card"
  }, {
    path: "/rejection",
    component: _3ae5339b,
    name: "rejection"
  }, {
    path: "/signature",
    component: _76f750ca,
    name: "signature"
  }, {
    path: "/ssuccess",
    component: _d5a36be4,
    name: "ssuccess"
  }, {
    path: "/success",
    component: _905b1dd6,
    name: "success"
  }, {
    path: "/timeout",
    component: _efaac11a,
    name: "timeout"
  }, {
    path: "/upload-documents",
    component: _74d6e978,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _4ac12a3b,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _4acf41bc,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _4aeb70be,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _4af9883f,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _7fa7657c,
    name: "errors-500"
  }, {
    path: "/patient/patient-information",
    component: _2c3b1746,
    name: "patient-patient-information"
  }, {
    path: "/patient/success",
    component: _0dc503fc,
    name: "patient-success"
  }, {
    path: "/representative/patient-information",
    component: _4248d50e,
    name: "representative-patient-information"
  }, {
    path: "/representative/success",
    component: _711c21d0,
    name: "representative-success"
  }, {
    path: "/",
    component: _a9e9de38,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
